export default __webpack_public_path__ + "static/media/puhelin-lightblue.dff311e7.svg";